import { RouteProps } from '../../routes/AppRouter'
import React from 'react'
import { CalendarForm as CF } from '../../features/calendar'
import { ROUTE_CREATE } from '../../routes/routes-constants'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

type CalendarFormProps = {
  date?: Date
  currentUrl?: string
} & RouteProps

export function CalendarForm(props: CalendarFormProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)
  const state: CalendarFormProps = props.location?.state as CalendarFormProps

  return (
    <CF
      id={props.id === ROUTE_CREATE ? undefined : props.id}
      date={state.date}
      currentUrl={state.currentUrl}
    />
  )
}
